export const customColors = {
    white: '#ffffff',
    black: '#000000',
    geekblue_10: '#030852',
    purple_10: '#120338',
    blue_7: '#193550',
    blue_6: '#3e82f7',
    gray_8: '#595959',
    gray_7: '#8C8C8C',
    gray_5: '#D9D9D9',
    gray_3: '#F5F5F5',
    gray_2: '#FAFAFA',
    gray_1: '#DFDFDF',
    green_6: '#52C41A',
    gray_120: '#f7f5f5',
    primary_50: '#F2F4F6',
    primary_70: '#e0eeff',
    primary_100: '#f4f9fe',
    primary_150: '#1473e6',
    primary_200: '#0d66d0',
    primary_300: '#095aba',
    primary_400: '#363550',
    primary_450: '#0069D1',
    primary_600: '#212139',
    primary_700: '#363550',
    primary_750: '#3b73ea',
    primary_800: '#43425d',
    primary_850: '#2680eb',
    primary_900: '#001A34',
    gray_20: '#fafafa',
    gray_50: '#f5f5f5',
    gray_65: '#e5e5e5',
    gray_75: '#efedff',
    gray_80: '#eaeaea',
    gray_100: '#e2dfff',
    gray_150: '#dfdfdf',
    gray_170: '#777593',
    gray_200: '#f5f5f5',
    gray_250: '#e0e0e0',
    gray_270: '#a09ebd',
    gray_300: '#707070',
    gray_320: '#cacaca',
    gray_350: '#9e9e9e',
    gray_370: '#b3b3b3',
    gray_400: '#d2d2d2',
    gray_480: '#A9A9A9',
    gray_450: '#8b8b8b',
    gray_470: '#8e8e8e',
    gray_500: '#707070',
    gray_550: '#8a8a8a',
    gray_600: '#6e6e6e',
    gray_650: '#637180',
    gray_700: '#4b4b4b',
    gray_900: '#2c2c2c',
    acsent_700: '#3b86ff',
    acsent_600: '#3840b7',
    acsent_200: '#304ffe',
    acsent_100: '#e0e8ff',
    black_900: '#212121',
    red_70: '#ffe0e0',
    red_75: '#ffe0f1',
    red_100: '#ffe3e0',
    red_200: '#d50000',
    red_250: '#c9252d',
    red_400: '#ED1C24',
    red_600: '#BE0007',
    red_650: '#EA2125',
    red_700: '#840004',
    red_750: '#ce2783',
    green_70: '#e0feff',
    green_100: '#e0ffe9',
    green_120: '#eeffe0',
    green_150: '#e0fff5',
    green_200: '#00c853',
    green_250: '#7cc33f',
    green_450: '#268e6c',
    green_500: '#12805c',
    green_550: '#73b53a',
    green_600: '#21ea71',
    green_650: '#25b37c',
    green_800: '#16878c',
    yellow_150: '#fffae0',
    yellow_900: '#c4a600',
    yellow_400: '#0088ff',
    perpule_100: '#eee0ff',
    perpule_600: '#864ccc',
    perpule_700: '#7a42bf',
    orange_150: '#fff1e0',
    orange_700: '#eb7012',
    orange_850: '#b79900',
};